import request from './adminRequest'

export const freeOpenCourseApi = {
  listFreeOpenCourse (params) {
    return request.get('/freeOpenCourses', { params: params })
  },
  getFreeOpenCourse (id) {
    return request.get('/freeOpenCourses/' + id)
  },
  saveFreeOpenCourse (data) {
    return request.post('/freeOpenCourses', data)
  },
  updateFreeOpenCourse (id, data) {
    return request.put('/freeOpenCourses/' + id, data)
  },
  deleteFreeOpenCourse (id) {
    return request.delete('/freeOpenCourses/' + id)
  },

}
export default freeOpenCourseApi
